export default function evaluateQuiz(answers) {
    const totalQuestions = answers.length;
    const minCorrectAnswers = Math.ceil(totalQuestions * 0.8); // Mínimo 80% correctas para aprobar
  
    const correctAnswers = answers.filter(answer => answer.correct).length;
  
    return correctAnswers >= minCorrectAnswers;
  }